import type { GroupDto } from "@ied/shared-types";
import { useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useGetGroups() {
	return useQuery({
		queryKey: ["groups"],
		queryFn: async () => {
			const res = await fetch(`${SERVICE_API}/api/groups`, {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to fetch groups");
			}

			return (await res.json()) as GroupDto[];
		},
	});
}
